import { environmentConfig } from 'environments/config/config'

const { API_GATEWAY_URL } = environmentConfig

export const getCurrenciesURL = () => {
  return `${API_GATEWAY_URL}/currencies`
}

export const getOrdersURL = () => {
  return `${API_GATEWAY_URL}/support/orders`
}

export const postAuthLinkURL = () => {
  return `${API_GATEWAY_URL}/support/auth-link`
}

export const postSearchCustomersURL = () => {
  return `${API_GATEWAY_URL}/support/search/customers`
}

export const postPortalSessionURL = () => {
  return `${API_GATEWAY_URL}/support/portal-session`
}

export const postPaymentPortalSessionURL = () => {
  return `${API_GATEWAY_URL}/support/payment-portal-session`
}

export const postEuWithdrawalURL = () => {
  return `${API_GATEWAY_URL}/support/eu-withdrawal`
}
